export default __webpack_public_path__ + "static/media/metal_reflection_blur.ef2a9e05.png";